var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitchCamera = function SvgSwitchCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.688 24.688 16 20 11.312v3.375h-8v-3.375L7.312 16 12 20.688v-3.375h8zm6.688-15.375c1.438 0 2.625 1.25 2.625 2.688v16c0 1.438-1.188 2.688-2.625 2.688H5.313c-1.438 0-2.625-1.25-2.625-2.688v-16c0-1.438 1.188-2.688 2.625-2.688h4.25l2.438-2.625h8l2.438 2.625z"
  })));
};
export default SvgSwitchCamera;